import { ReminderRow } from "./ReminderRow";

export function RemindersList({ reminders, onEdit, onDelete }) {
  return (
    <div className="max-w-3xl">
      <div className="bg-white rounded-lg border border-gray-200 divide-y divide-gray-200 overflow-hidden">
        {reminders.map((reminder, i) => (
          <ReminderRow
            key={reminder.reminderId}
            reminder={reminder}
            onEdit={onEdit}
            onDelete={onDelete}
            isLast={i === reminders.length - 1}
          />
        ))}
      </div>
    </div>
  );
}
